<template>
  <section class="closing">
    <p class="closing__text">
      <span
        class="closing__content"
        v-for="text in texts"
        :key="text.content"
        :style="{
          left: `${text.left}px`,
          transform: `translate3d(${-scrollValue}px, 0, 0)`
        }"
      >
        {{text.content}}
      </span>
    </p>
  </section>
</template>

<script>
import loop from 'raf-loop';
import FontFaceObserver from 'fontfaceobserver';
import debounce from 'lodash.debounce';

import list from '@/assets/data/infoclosing.json';


export default {
  name: 'InfoClosing',

  data() {
    return {
      list,
      texts: [],
      scrollValue: 0,
      totalWidth: 0,
    };
  },

  created() {
    this.list.forEach((text) => {
      this.texts.push({
        content: text,
        left: 0,
        width: 0,
      });
    });
  },

  mounted() {
    const font = new FontFaceObserver('Neutral', {
      weight: 500,
    });

    font.load().then(() => {
      this.setEls();
      this.engine = loop(this.renderer).start();
    }, () => {
      this.setEls();
      this.engine = loop(this.renderer).start();
    });

    this.handlerResize = () => debounce(this.resize(), 300);

    window.addEventListener('resize', this.handlerResize);
  },

  methods: {
    renderer() {
      this.scrollValue += 2;

      this.texts.forEach((el) => {
        if ((this.scrollValue - el.left) > el.width) {
          el.left = this.totalWidth;
          this.totalWidth = this.totalWidth + el.width;
        }
      });
    },

    setEls() {
      const nodes = Array.from(this.$el.querySelectorAll('.closing__content'));
      let left = 0;
      this.totalWidth = 0;

      this.texts.forEach((el) => {
        el.node = nodes.find(node => node.innerText === el.content);
        el.left = left;
        el.width = el.node.clientWidth;

        el.node.style.left = `${left}px`;

        left += el.width;
        this.totalWidth += el.width;
      });
    },

    resize() {
      console.log(1);
      this.scrollValue = 0;

      this.setEls();
    },
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handlerResize);

    this.engine.stop();
    this.engine = null;
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.closing {
  position: relative;
  width: 100%;
  height: 150px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  overflow: hidden;

  @include mq(sm) {
    height: 500px;
  }

  .closing__text {
    position: relative;
    width: 100%;
    height: 80px;
    white-space: nowrap;

    @include mq(sm) {
      transform: translateY(-100%);
    }

    &:hover span {
      color: $color-blue;
    }

    .closing__content {
      position: absolute;
      white-space: nowrap;
      display: block;

      font-size: 2.1875rem;
      font-weight: 500;
      -webkit-text-stroke: 1px $color-blue;
      color: transparent;
      text-decoration: none;

      @include mq(sm) {
        font-size: 3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InfoClosing.vue